import { useEffect } from 'react';
import { useState } from 'owa-react';

/**
 * Hook will load an image and return a boolean for current loaded state
 * @param avatarUrl image URL to load
 * @returns a boolean indicating if image is loaded
 */
export default function useImageLoading(avatarUrl: string): boolean {
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    useEffect(() => {
        let isCancelled = false;

        const img = new Image();

        img.onload = () => {
            if (!avatarUrl) {
                setIsImageLoaded(false);
            } else if (!isCancelled) {
                setIsImageLoaded(true);
            }
        };

        img.onerror = () => {
            if (!isCancelled) {
                setIsImageLoaded(false);
            }
        };

        img.src = avatarUrl;

        return () => {
            isCancelled = true;
            img.onload = null;
            img.onerror = null;
        };
    }, [avatarUrl]);

    return isImageLoaded;
}
